import { Button, Grid, IconButton, InputAdornment, LinearProgress, TextField } from '@mui/material';
import Table from '@mui/material/Table';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import debounce from 'lodash.debounce';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingBasket, faTrashAlt } from '@fortawesome/free-solid-svg-icons'

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';

function createData(id, name, pack, price, amount) {
    return { id, name, pack, price, amount };
}

function createDataCart(name, amount, price) {
    return {name, amount, price};
}

const APIBASE = "https://afrodita-kozmetika.hu/api/csv.php";
const APIBASE2 = "https://afrodita-kozmetika.hu/api/szeminarium.php";  

function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
  }

function Money({userID}){

    const [loaded] = useState(true)
    const [data, setData] = useState([]);
    const [rows, setRows] = useState([]);
    const [cartRows, setCartRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [cart, setCart] = useState([]);
    const [money, setMoney] = useState(0);
    const [cartOpen, setCartOpen] = useState(true);
    const [showRows, setShowRows] = useState([])
    const [invoice, setInvoice] = useState(false);

    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [error, setError] = useState(false);


    const getDatas = async () => {
        const response = await axios
        .get(APIBASE)
        setData(response.data);
    }
    

    useEffect(() => {
        setData([])
        getDatas();

        console.log()

        if(JSON.parse(localStorage.getItem("afroditaCart")) !== null){
            setCart(JSON.parse(localStorage.getItem("afroditaCart")))
        }       

    }, [loaded])

    useEffect(() => {
        console.log(cart)
    }, [cart])

    useEffect(() => {
        if(data.length > 0){

            let roww = [];

            setLoading(true)
            data.forEach((row) => {
                let dat = row.data.toString().split(';');
                roww.push(createData(dat[0], dat[1], dat[2], dat[3]))
            })
            setRows(roww)
            setLoading(false)
        }
    }, [data])

    useEffect(() => {
        setShowRows(rows);
    }, [rows])

    useEffect(() => {
        let i = 0;
        let items = [];

        cart?.forEach((item) => {
            items.push(createDataCart(item.name, item.amount, item.price))
            i += item.amount*item.price;
        })
        setCartRows(items)
        setMoney(i)

    }, [cart])

    function addToCart(id, amount, price, name, pack){

        let i = 0;
        let carts = [];

        if(cart.length > 0){
            carts = [...cart];
        }

        cart?.forEach((item, idx) => {
            if(item.id === id){
                cart[idx].amount = amount;
                i+=1;
            }   
        })

        if(i === 0){
            carts.push({id: id, amount: amount, price, name, pack})
        } 

        localStorage.setItem('afroditaCart', JSON.stringify(carts))
        setCart(carts)
    }

    function deleteFromCart(name){

        console.log(name)

        let carts = [];
        cart.forEach((element) => {
            if(element.name !== name){
                carts.push(element)
            }
        })

        localStorage.setItem('afroditaCart', JSON.stringify(carts))
        setCart(carts);
    }
    

    function Order(){

        let data = JSON.stringify({
            "order": false,
            "name": userID.name,
            "email": userID.email,
            "phone": userID.phone,
            "products": cart,
            "invoice": invoice
        })

        axios
        .post(APIBASE2, data ,{
            headers: {
                'Content-Type': 'application/json',
            }})
        .then(() => {
            console.log("asd")
            setSnackBarOpen(true);
            setCart([]);
            localStorage.removeItem('afroditaCart');
        })
        .catch((error) => {
            console.log(error.response)
            setError(true);
        })

    }

    const changeHandler = event => {

        if(event.target.value.length > 0){
            const filteredRows = rows.filter((row) => {
                return row.name.toLowerCase().includes(event.target.value.toLowerCase());
            });
    
            setShowRows(filteredRows);
        }
        else{
            setShowRows(rows);
        }

        console.log(event.target.value)
      };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const debounceChange = useCallback(
        debounce(changeHandler, 300)
    )

    return (
        <div>
            {loading ? 
                <LinearProgress/>
            :
            <div>

            <div style={{height: '100vh', width: '100%', position: 'fixed', background: '#fff', zIndex: 9999999, top: 0, left: 0, display: snackBarOpen ? 'block' : 'none'}}>
                <div style={{top: '50%', left: '50%', position: 'absolute', transform: 'translate(-50%, -50%)'}}>
                    <div style={{textAlign: 'center', fontSize: 32, fontWeight: 'bold', color: '#53a653'}}>
                        Sikeres megrendelés!
                    </div>
                    <div style={{textAlign: 'center', fontSize: 24, color: '#53a653'}}>
                        Kollégánk hamarosan felveszi Veled a kapcsolatot.
                    </div>

                    <div style={{textAlign: 'center', marginTop: 30}}>

                        <Button onClick={() => setSnackBarOpen(false)} variant="outlined">Új megrendelést adok le</Button>
                    </div>
                </div>
            </div>

            <div style={{height: '100vh', width: '100%', position: 'fixed', background: '#fff', zIndex: 9999999, top: 0, left: 0, display: error ? 'block' : 'none'}}>
                <div style={{top: '50%', left: '50%', position: 'absolute', transform: 'translate(-50%, -50%)'}}>
                    <div style={{textAlign: 'center', fontSize: 32, fontWeight: 'bold', color: 'red'}}>
                        Sikertelen mentés, 
                    </div>
                    <div style={{textAlign: 'center', fontSize: 24, color: 'red'}}>
                        kérlek próbáld meg később!
                    </div>

                    <div style={{textAlign: 'center', marginTop: 30}}>

                        <Button onClick={() => setError(false)} variant="outlined">Vissza</Button>
                    </div>
                </div>
            </div>

            <TextField fullWidth InputProps={{ endAdornment: <InputAdornment position="end">Keresés</InputAdornment>, }} size="small" onChange={debounceChange} />

                <div className={'cart'} style={{ display: cartOpen ? "block" : "none"}}>
                    <List style={{background: "#f0f0f0",  boxShadow: "0px 0px 15px rgba(0, 0, 0, 0.1)", borderRadius: "4px"}}>
                        <ListItem>
                            <div style={{textAlign: "center", width: "100%", fontSize: "20px", paddingBottom: "5px"}}>
                                Kosár tartalma
                            </div>
                        </ListItem>
                            <div>
                                <Divider />
                                <ListItem>
                                    <TableContainer sx={{ maxHeight: 440, maxWidth: 440 }}>
                                        <Table stickyHeader aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{fontWeight: "bold"}}>Termék megnevezés</TableCell>
                                                    <TableCell style={{fontWeight: "bold"}}>Darabszám</TableCell>
                                                    <TableCell style={{fontWeight: "bold"}}>Ár</TableCell>
                                                    <TableCell style={{fontWeight: "bold"}}></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {cartRows.map((row, idx) => {
                                                    return(

                                                        row.amount > 0 
                                                        ? 
                                                        <TableRow key={row.name + "_" + idx} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                        >
                                                            <TableCell>{row.name}</TableCell>
                                                            <TableCell>{row.amount} db</TableCell>
                                                            <TableCell>{formatNumber(row.amount*row.price)} Ft</TableCell>
                                                            <TableCell><FontAwesomeIcon onClick={() => deleteFromCart(row.name)} style={{color: "orange", cursor: "pointer"}} icon={faTrashAlt}/></TableCell>
                                                        </TableRow>
                                                        : 
                                                            ''
                                                        )

                                                        
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </ListItem>
                            </div>

                        <Divider />
                        <ListItem>

                            {money > 0 
                            
                            ?
                                <div style={{width: "100%", paddingTop: "5px"}}>
                                    <Grid container style={{display: 'flex', alignItems: 'center'}}>
                                        <Grid style={{paddingTop: "8px"}} xs={6}>
                                            <strong>Fizetendő: </strong> {formatNumber(money)} Ft
                                         </Grid>
                                         <Grid style={{paddingTop: "8px"}} xs={6}>
                                            <FormControlLabel
                                                control={<Checkbox checked={invoice} onChange={(_, e) => setInvoice(e)} name="antoine" />}
                                                label="Kérek számlát"
                                            />
    
                                         </Grid>
                                        <Grid xs={12}>
                                            <div><Button onClick={() => Order()} variant="contained">Vásárlás elküldése</Button></div>
                                        </Grid>
                                    </Grid>
                                    


                                    
                                </div>
                            :
                                <div style={{textAlign: "center", width: "100%", paddingTop: "5px"}}>
                                    A kosár jelenleg üres
                                </div>
                            }
                        </ListItem>
                    </List>
                </div>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TableContainer>
                            <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{fontWeight: "bold"}}>Kód</TableCell>
                                        <TableCell style={{fontWeight: "bold"}}>Termék megnevezés</TableCell>
                                        <TableCell style={{fontWeight: "bold"}}>Kiszerelés</TableCell>
                                        <TableCell style={{fontWeight: "bold"}}>Ár</TableCell>
                                        <TableCell style={{fontWeight: "bold"}}>Darabszám</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {showRows.map((row, idx) => {

                                        let amount = 0;

                                        cart?.filter(item => item.id === row.id).map(filteredItem => amount = filteredItem.amount);

                                        return(
                                            <TableRow key={row.name + "_" + idx} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <TableCell component="th" scope="row">
                                                    {row.id}
                                                </TableCell>
                                                <TableCell>{row.name}</TableCell>
                                                <TableCell>{row.pack}</TableCell>
                                                <TableCell>{row.price} Ft</TableCell>
                                                <TableCell><TextField type={'number'} InputProps={{ inputProps: { min: 0 }, endAdornment: <InputAdornment position="end">db</InputAdornment>, }} defaultValue={amount > 0 ? amount : ''} size="small" onChange={(event) => {addToCart(row.id, event.target.value, row.price, row.name, row.pack)}} /></TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>
                </Grid>

                <div style={{position: "fixed", left: "20px", bottom: "20px"}}>
                    <IconButton onClick={() => setCartOpen(!cartOpen)} aria-label="delete" color="primary">
                        <FontAwesomeIcon icon={faShoppingBasket}/>
                    </IconButton>
                </div>
            </div>
            }
        </div>

    )
}

export default Money;